import { filter_day, filter_month, filter_week } from '../../../../../views/marketing/overview/PeriodFilter';

export default {
  filters: {
    [filter_day]: 'Jour',
    [filter_week]: 'Semaine',
    [filter_month]: 'Mois',
    null: 'Total',
  },
};
